import React, { Component } from 'react';
import propTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';

import DropDown from './DropDown';
import getDropdownProperties from '../../../../cra/src/components/userDocuments/editDocument/editResume/Toolbar/ToolbarItems/getDropdownProperties';
import {
  ROLES,
  TAB_INDICES,
} from '../../../../cra/src/constants/accessibility';
import {
  HeadingFG,
  PrimaryDark,
  PrimaryMedium,
  white,
} from '../../../../cra/src/styling/theme';
import breakpointsMinWidth from '../../../../cra/src/styling/breakpointsMinWidth';
import { Chevron } from '../../../../cra/src/components/userDocuments/editDocument/editJournal/toolset/assets/icons';
import { routes } from '../../../utilities/constants';
import CustomizedDropdown from '../../../../cra/src/components/common/dropdowns/Dropdown';
import keyboardTypes from '../../../../cra/src/components/userDocuments/editDocument/editJournal/constants/keyboardTypes';
import { cleanPathname, featurePages } from '../../../constants/navbar';

const fadeInDown = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, -4%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
// import './ToolbarItems.css';

const Text = styled.span`
  cursor: pointer;
  color: ${HeadingFG};
  width: max-content;
  display: flex;
  align-items: center;
  position: relative;

  padding: 12px 0;
  font-size: 14px;

  &:hover .drop-down {
    display: block;
    animation: ${fadeInDown} 0.2s ease-out;
  }

  ${(props) => {
    const { pathName, isTop } = props;
    if ((pathName === '/about-us' || pathName === '/about-us/') && isTop) {
      return css`
        color: ${white};
      `;
    }

    if (pathName.includes('/documents/'))
      return css`
        color: ${HeadingFG};
      `;

    if (pathName.includes(routes.DRIVE))
      return css`
        color: ${HeadingFG};
      `;

    return null;
  }}

  /**
  * Reusable component for drop downs
  * We need to send the className's as props to this component and apply to TextItem
  * Styled components would match the respective class and apply styles
  */

  &.journal,
  &.thesis,
  &.resumeList,
  &.coverLetterList,
  &.file-editor,
  &.edit-editor,
  &.insert-editor,
  .profileIcon {
    position: relative;
    .drop-down,
    .profile {
      padding: 1rem;
      background-color: #fff;
      border-radius: 4px;
      z-index: 3;
      font-size: 12px;
      @media ${breakpointsMinWidth.desktopMd} {
        font-size: 14px;
      }

      li {
        font-size: 12px;
        color: ${HeadingFG};
        text-align: center;
        @media ${breakpointsMinWidth.desktopMini} {
          line-height: 28px;
        }
        @media ${breakpointsMinWidth.desktopLg} {
          padding: 6px 0;
        }
        @media ${breakpointsMinWidth.desktopMd} {
          font-size: 14px;
        }
        &:hover {
          background: none;
          color: ${PrimaryDark};
          font-weight: 400;
        }
      }
    }
  }

  &.file-editor,
  &.edit-editor,
  &.insert-editor {
    position: relative;

    font-size: 12px;

    transition: background 0.3s ease-out;
    @media ${breakpointsMinWidth.desktopMd} {
      font-size: 14px;
    }
    .drop-down {
      left: 0;

      padding: 8px 0;
      margin: 4px 0 0 0;

      border-radius: 2px;
      ul {
        width: 200px;

        li {
          font-size: 12px;
          text-align: left;

          padding: 6px 16px;

          margin: 0;

          transition: background 0.3s ease-out;

          &:hover {
            font-weight: 500;
            background: rgba(71, 56, 128, 0.1);

            .mutsSVG {
              fill: #473880;
            }
          }
          @media ${breakpointsMinWidth.desktopMd} {
            font-size: 14px;
          }
        }
      }
    }
  }

  &.journal,
  &.thesis,
  &.resumeList,
  &.coverLetterList,
  &.pricing {
    font-weight: 500;
    transition: color 0.3s ease-out;

    font-size: 12px;
    @media ${breakpointsMinWidth.desktopMd} {
      font-size: 14px;
    }

    .drop-down {
      left: auto;
      margin-top: 12px;
    }

    &:hover {
      color: #8510df;
    }
  }

  &.resumeList,
  &.coverLetterList {
    font-size: 16px;

    @media ${breakpointsMinWidth.desktopLg} {
      font-size: 20px;
    }
  }

  &.resumeList,
  &.coverLetterList {
    .resumeDropdown,
    .coverLetterDropdown {
      padding: 0;
    }
  }
`;

const InnerText = styled.span`
  /* background: ${(props) =>
    props.show ? 'rgba(162, 162, 162, 0.13)' : null}; */
  opacity: ${({ show, isTop }) => (show && isTop ? 0.8 : 1)};
  ${({ pathName, isTop }) => {
    const isFeaturePage =
      featurePages.includes(cleanPathname(pathName)) && pathName !== '/';
    if ((pathName === '/' && isTop) || isFeaturePage) {
      return css`
        color: ${white};
      `;
    }
    return css``;
  }}
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 14px;
  font-weight: 400;
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;

const NavChevron = styled.span`
  display: ${(props) => (props.appType === 'CRA' ? 'none' : 'flex')};
  svg {
    width: 16px;
    height: 16px;
    text-align: center;
    transform: rotate(90deg);
    ${({ pathName, isTop }) => {
      const isFeaturePage =
        featurePages.includes(cleanPathname(pathName)) && pathName !== '/';
      if ((pathName === '/' && isTop) || isFeaturePage) {
        return css`
          fill: ${white};
        `;
      }
      return css``;
    }}
  }

  @media screen and (min-width: 1920px) {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

class TextItem extends Component {
  state = {
    show: false,
    rotate: false,
  };

  parentRef = React.createRef();

  handleOpenDropdown = (e) => {
    e?.stopPropagation();
    const {
      listItem: { className },
    } = this.props;
    const { show } = this.state;
    const dropdownState = getDropdownProperties({
      e,
      show,
      ref: this.parentRef,
      className,
    });
    this.setState({
      ...dropdownState,
    });
  };

  handleCloseDropdown = (e) => {
    const {
      target: { classList },
    } = e;
    const isAnchorClicked = classList.contains('url');
    if (isAnchorClicked) {
      setTimeout(() => {
        this.setState({
          show: false,
        });
      }, 300);
      return;
    }

    setTimeout(() => {
      this.setState({
        show: false,
      });
    }, 0);
  };

  handleMouseEnter = () => {
    this.setState({ show: true });
  };

  handleMouseLeave = () => {
    this.setState({ show: false });
  };

  render() {
    const { listItem, pathName, isTop, appType, LinkComponent } = this.props;
    const { text, childrenList, className, dropdownName } = listItem;
    const { show, rotate } = this.state;

    const ChevFill = () => {
      if ((pathName === '/about-us' || pathName === '/about-us/') && isTop) {
        return rotate ? PrimaryMedium : '#fff';
      }
      return rotate ? PrimaryMedium : HeadingFG;
    };

    const isEditor = pathName.includes(routes.EDITOR);

    const itemsList = childrenList?.map((item) => {
      return {
        item: item.text,
        triggerFunction: item?.triggerFunction,
        hasPopover: '',
        popoverData: undefined,
        shortcut: item?.shortCut,
        isDisabled: false,
      };
    });

    return (
      <Text
        className={`${className} h-full`}
        ref={this.parentRef}
        onMouseDown={(e) => {
          if (!isEditor) {
            this.handleOpenDropdown();
          }
          if (isEditor) {
            e.stopPropagation();
            this.handleMouseEnter();
          }
        }}
        role={ROLES.BUTTON}
        tabIndex={TAB_INDICES.ZERO}
        pathName={pathName}
        isTop={isTop}
        show={show}
        onMouseEnter={() => this.setState({ rotate: true, show: true })}
        onMouseLeave={() => this.setState({ rotate: false, show: false })}
      >
        <InnerText pathName={pathName} isTop={isTop} show={show}>
          {text}
        </InnerText>
        <NavChevron pathName={pathName} isTop={isTop} appType={appType}>
          <Chevron className="accordion__icon rotate" fill={ChevFill()} />
        </NavChevron>
        {!isEditor && (
          <DropDown
            className={`drop-down ${dropdownName}`}
            type={text}
            top="48"
            childrenList={childrenList}
            appType={appType}
            handleCloseDropdown={this.handleCloseDropdown}
            parentMenuClassName={dropdownName}
            LinkComponent={LinkComponent}
          />
        )}
        {isEditor && (
          <div
            role="button"
            tabIndex={0}
            onClick={this.handleMouseLeave}
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            onKeyDown={(e) => {
              if (e.key === keyboardTypes.ENTER || e.key === ' ') {
                this.handleMouseLeave();
              }
            }}
          >
            <CustomizedDropdown
              isOpen={show}
              top="38"
              left="0"
              closeDropdown={() => this.setState({ show: false })}
              itemsList={itemsList}
              sectioned={false}
              styleClasses="w-[180px] text-left"
            />
          </div>
        )}
      </Text>
    );
  }
}

TextItem.propTypes = {
  listItem: propTypes.shape({
    type: propTypes.string,
    text: propTypes.string,
    childrenList: propTypes.arrayOf(propTypes.object),
  }),
  pathName: propTypes.string,
  isTop: propTypes.bool,
};

TextItem.defaultProps = {
  listItem: {
    type: 'text',
    text: 'Insert',
    childrenList: [{}],
  },
  pathName: '',
  isTop: false,
};

export default TextItem;
